import * as React from "react";

import {Types} from "@Common/types";
import {chain} from "@Common/utils/fs";

type Branch = Types.Apis.Payloads.Next.Branch.GetAll.Response[number];

export const mapBranchAsLabel = (branch:Pick<Branch, "branchLinkId" | "branchName">): JSX.Element => chain(
    branch.branchName || branch.branchLinkId,
    (label) => <span title={label} xd-qa-type="dropdown_item" xd-qa-name={`Office ${label}`}>{label}</span>
);
